import useLanguage from 'hooks/useLanguage';
import {Chip} from '@mui/material';
import {LocalizationComponent} from './LocalizationComponent';
import {DatePicker, type DatePickerProps} from '@mui/x-date-pickers/DatePicker';
import {type UseDateFieldProps} from '@mui/x-date-pickers/DateField';
import type {
  BaseSingleInputFieldProps,
  DateValidationError,
  FieldSection,
  PickerChangeHandlerContext,
} from '@mui/x-date-pickers/models';
import {useState} from 'react';

export const FilterDatePicker = ({
  minDate,
  maxDate,
  value,
  onDateChange,
}: {
  minDate?: Date;
  maxDate?: Date;
  value: Date;
  onDateChange: (value: Date | null, context: PickerChangeHandlerContext<DateValidationError>) => void;
}) => {
  const {dateFormatter} = useLanguage();
  return (
    <LocalizationComponent>
      <ButtonDatePicker
        label={dateFormatter.toDateString(value)}
        value={value}
        minDate={minDate}
        maxDate={maxDate}
        format={dateFormatter.getDateFormat()}
        onChange={onDateChange}
      />
    </LocalizationComponent>
  );
};

interface ButtonFieldProps
  extends UseDateFieldProps<Date, false>,
    BaseSingleInputFieldProps<Date | null, Date, FieldSection, false, DateValidationError> {
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

function ButtonField(props: ButtonFieldProps) {
  const {setOpen, label, id, disabled, InputProps: {ref} = {}, inputProps: {'aria-label': ariaLabel} = {}} = props;

  return (
    <Chip
      variant="outlined"
      size="small"
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      label={label}
      onClick={() => setOpen?.((prev) => !prev)}
    />
  );
}

function ButtonDatePicker(props: Omit<DatePickerProps<Date>, 'open' | 'onOpen' | 'onClose'>) {
  const [open, setOpen] = useState(false);

  return (
    <DatePicker
      slots={{...props.slots, field: ButtonField}}
      slotProps={{...props.slotProps, field: {setOpen} as any}}
      {...props}
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      onOpen={() => {
        setOpen(true);
      }}
      displayWeekNumber={true}
    />
  );
}
